import { useQuery } from "@tanstack/react-query";
import { getProductCategoryFeesByCategoryId } from "@/services/pricing-config.service";

export const useProductCategoryFeesByCategoryId = (
  id,
  params = {},
  enabled = true,
  options = {},
) => {
  return useQuery({
    queryKey: ["product-category-fees", id, params],
    queryFn: () => getProductCategoryFeesByCategoryId({ id, params }),
    enabled: enabled && !!id,
    ...options,
  });
};
